import type { ICellRendererParams } from 'ag-grid-community';
import type { Closure } from '../../schema';

/**
 * is_active pill. Closures don't have a draft/published workflow — just
 * an on/off toggle that the form controls. Cell renders Active vs Disabled.
 */
export function StatusBadge(p: ICellRendererParams<Closure, boolean>) {
  const active = p.value;
  if (active === undefined || active === null) return null;

  const bg = active ? 'bg-success/15' : 'bg-foreground-muted/15';
  const text = active ? 'text-success' : 'text-foreground-muted';
  const dot = active ? 'bg-success' : 'bg-foreground-muted';

  return (
    <span
      className={[
        'inline-flex w-fit shrink-0 items-center gap-1.5 self-center rounded-full px-2 py-[3px]',
        'text-[10px] font-black uppercase leading-none tracking-tight',
        bg,
        text,
      ].join(' ')}
    >
      <span aria-hidden className={`h-1.5 w-1.5 shrink-0 rounded-full ${dot}`} />
      <span>{active ? 'Active' : 'Disabled'}</span>
    </span>
  );
}
